import React from 'react'
import './Dash.css'
import NavBar from '../Components/NavBar'
import LeftBar from '../Components/LeftBar'
import PriceComp from './PriceComp'

function PricesCalculator() {
  return (
<div className='contentMain'> 
        <LeftBar/>
        <div className='theRightOne'> 
          <div className='DashTop'>
            <h1>Settings</h1>
            <NavBar/>
          </div>
          <PriceComp/>
        </div>    
    </div>
  )
}

export default PricesCalculator